import graphqlClient from "@/GQLClient";
import {
  GetSummarizedMeetingsOnMyInstitutionDocument,
  type Meeting,
  type EntityPagerFilter,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import type { IPagerResult } from "@/interfaces";

const getMeetings = async (
  filter: EntityPagerFilter,
): Promise<IPagerResult<Meeting>> => {
  const response = await graphqlClient.query({
    query: GetSummarizedMeetingsOnMyInstitutionDocument,
    variables: {
      filter,
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data.institutions?.getMyInstitution.meetings) {
    const { edges, pageInfo } =
      response.data.institutions.getMyInstitution.meetings;
    return {
      edges: edges.map((item) => item.node as Meeting),
      pageInfo,
    };
  }

  throw new SentryGraphQLError(`api.meetings.getMeetings`, response);
};

export default {
  getMeetings,
};
